import React, { memo, useState } from 'react';
import { makeStyles } from '@mui/styles';
import { TextField, IconButton } from '@mui/material';
import { Controller } from 'react-hook-form';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { COPIED_TO_CLIPBOARD } from '../../../constants/strings';

const helperTextStyles = makeStyles(() => ({
  root: {
    '&.Mui-disabled': {
      color: '#4C9C2E',
    },
  },
}));

const DriverPassword = ({ password, control }) => {
  const helperClass = helperTextStyles();
  const [helperText, setHelperText] = useState('');

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(password);
      setHelperText(COPIED_TO_CLIPBOARD);
    } catch {
      setHelperText('Clipboard permission denied');
    }
  };

  return (
    !!password && (
      <>
        <Controller
          name="password"
          defaultValue={password}
          control={control}
          render={({ field }) => (
            <TextField
              {...field}
              type="text"
              label="New Password"
              disabled
              variant="outlined"
              helperText={helperText}
              FormHelperTextProps={{ classes: helperClass }}
              data-testid="driver-password"
              InputProps={{
                endAdornment: (
                  <IconButton
                    aria-label="copy password"
                    onClick={handleCopy}
                    edge="end"
                    size="small"
                    tabIndex={-1}
                  >
                    <ContentCopyIcon fontSize="small" />
                  </IconButton>
                ),
              }}
            />
          )}
        />
      </>
    )
  );
};

export default memo(DriverPassword);
